module.exports = __webpack_public_path__ + "assets/quanpin1.eb3e834ca9ea5d27c1ab0b9daa8cda01.png";